import { lazy } from 'react';
import { useLocation } from 'react-router-dom';
import { LayoutType } from '../../shared/types/LayoutType';
import type { CommonType } from '../../shared/types/CommonType';
import { CommentNotificationsProvider } from '../../features/files/context/CommentNotificationsContext';
import { OnboardingModal, OnboardingTour } from './components/Onboarding';
import { ShortcutsCheatSheet } from './components/ShortcutsCheatSheet';
import { isPublicGalleryRoute } from './resolveRouteLayout';

interface PostLoginLayoutProps extends CommonType {
  layoutType: LayoutType;
}

const layouts = {
  'sidebar-classic': lazy(() => import('./components/SidebarClassic')),
  'top-bar-classic': lazy(() => import('./components/TopBarClassic')),
  blank: lazy(() => import('./components/Blank')),
}

const PostLoginLayout = ({ layoutType, children }: PostLoginLayoutProps) => {
  const { pathname } = useLocation();

  if (isPublicGalleryRoute(pathname)) {
    return <>{children}</>;
  }

  const AppLayout = layouts[layoutType] ?? layouts['sidebar-classic'];
  
  return (
    <CommentNotificationsProvider>
      <AppLayout>{children}</AppLayout>
      <OnboardingModal />
      <OnboardingTour />
      <ShortcutsCheatSheet />
    </CommentNotificationsProvider>
  )
};

export default PostLoginLayout;